export const getAuth = state => state.auth;
